export const FETCH_FOLDER_FOR_MEDIA_REQUEST =
  "API/ENTITIES/FOLDERS/MEDIA_FOLDER_REQUEST";
export const FETCH_FOLDER_FOR_MEDIA_REQUEST_SUCCES =
  "API/ENTITIES/FOLDERS/MEDIA_FOLDER_REQUEST_SUCCESS";
export const FETCH_FOLDER_FOR_MEDIA_REQUEST_FAILURE =
  "API/ENTITIES/FOLDERS/MEDIA_FOLDER_REQUEST_FAILURE";
